var _rect, _path, _path2, _path3, _g, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _path5, _rect7, _rect8, _path6, _rect9, _rect10, _path7, _rect11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgServiceLoanStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 210,
    viewBox: "0 0 375 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.3945,
    y: 60.1621,
    width: 202.702,
    height: 128.656,
    fill: "#99C4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.912 124.491L235.098 59.9637L235.098 189.018L137.912 124.491Z",
    fill: "#B4D6FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.582 124.491L32.396 59.9637L32.396 189.018L129.582 124.491Z",
    fill: "#B4D6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M144.953 139.194C138.54 144.817 128.953 144.817 122.54 139.194L32.3953 60.1637H235.098L144.953 139.194Z",
    fill: "#E0EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_425_782)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.805,
    width: 155.498,
    height: 199,
    rx: 4,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.305,
    y: 0.5,
    width: 154.498,
    height: 198,
    rx: 3.5,
    stroke: "#EFF3F8"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.949 31.3125V49.0859H226.547V40.1992H224.887V48.2266H222.543V31.6055H224.887V38.1875H226.547V31.3125H228.949ZM214.34 44.75V33.2852H216.84V42.5723C218.266 42.5332 219.838 42.4062 221.547 42.0742L221.801 44.2227C219.418 44.6328 217.387 44.7598 215.551 44.75H214.34ZM247.113 39.7305V41.7227H230.902V39.7305H234.555V37.6016C233.256 37.0254 232.523 36.1465 232.523 35.0039C232.523 32.8555 235.053 31.5762 239.008 31.5664C242.934 31.5762 245.463 32.8555 245.473 35.0039C245.463 36.166 244.711 37.0547 243.383 37.6211V39.7305H247.113ZM232.758 45.8438C232.758 43.793 235.092 42.6504 238.988 42.6602C242.826 42.6504 245.16 43.793 245.18 45.8438C245.16 47.9434 242.826 49.0664 238.988 49.0664C235.092 49.0664 232.758 47.9434 232.758 45.8438ZM235.121 35.0039C235.102 35.9805 236.498 36.4785 239.008 36.4688C241.488 36.4785 242.895 35.9805 242.895 35.0039C242.895 34.0078 241.488 33.4805 239.008 33.4805C236.498 33.4805 235.102 34.0078 235.121 35.0039ZM235.297 45.8438C235.287 46.752 236.527 47.2109 238.988 47.2109C241.4 47.2109 242.67 46.752 242.68 45.8438C242.67 44.9648 241.4 44.5449 238.988 44.5352C236.527 44.5449 235.287 44.9648 235.297 45.8438ZM237.074 39.7305H240.902V38.2363C240.316 38.3145 239.682 38.3438 239.008 38.3438C238.314 38.3438 237.67 38.3047 237.074 38.2363V39.7305ZM264.398 39.4961V41.5078H248.188V39.4961H264.398ZM248.91 36.8984C252.25 36.5957 254.076 35.375 254.486 34.125H249.672V32.1328H262.934V34.125H258.08C258.48 35.3652 260.297 36.5957 263.715 36.8984L262.836 38.8516C259.477 38.5293 257.221 37.2598 256.273 35.541C255.336 37.2598 253.1 38.5293 249.73 38.8516L248.91 36.8984ZM250.043 45.8047C250.043 43.7148 252.387 42.5039 256.273 42.5039C260.131 42.5039 262.445 43.7148 262.465 45.8047C262.445 47.9043 260.131 49.0957 256.273 49.0859C252.387 49.0957 250.043 47.9043 250.043 45.8047ZM252.582 45.8047C252.572 46.7227 253.812 47.1523 256.273 47.1523C258.686 47.1523 259.955 46.7227 259.965 45.8047C259.955 44.877 258.686 44.4375 256.273 44.4375C253.812 44.4375 252.572 44.877 252.582 45.8047ZM280.453 31.3125V41.7227H277.973V39.457H274.652V40.7461H266.215V32.6211H274.652V33.9102H277.973V31.3125H280.453ZM268.266 45.6484C268.266 43.4609 270.59 42.1816 274.379 42.1914C278.178 42.1816 280.502 43.4609 280.512 45.6484C280.502 47.8457 278.178 49.0957 274.379 49.0859C270.59 49.0957 268.266 47.8457 268.266 45.6484ZM268.695 38.7734H272.211V34.5938H268.695V38.7734ZM270.746 45.6484C270.746 46.6641 272.025 47.1914 274.379 47.1914C276.742 47.1914 278.021 46.6641 278.031 45.6484C278.021 44.5938 276.742 44.0859 274.379 44.0859C272.025 44.0859 270.746 44.5938 270.746 45.6484ZM274.652 37.4453H277.973V35.8828H274.652V37.4453Z",
    fill: "#374969"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 189.805,
    y: 76,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189.805,
    y: 100,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 189.805,
    y: 124,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 189.805,
    y: 148,
    width: 84,
    height: 6,
    rx: 3,
    fill: "#DFDFDF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 266.504,
    y: 159.773,
    width: 85.8144,
    height: 16.2352,
    fill: "#56BA74"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M352.318 159.773H369.327V176.009H352.318V159.773Z",
    fill: "#4A935E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 302.066,
    y: 159,
    width: 14.6889,
    height: 17.7814,
    fill: "#CAEADB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 271.916,
    y: 192.244,
    width: 85.8144,
    height: 16.2352,
    fill: "#56BA74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.73 192.244H374.739V208.479H357.73V192.244Z",
    fill: "#4E9A63"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 307.479,
    y: 191.471,
    width: 14.6889,
    height: 17.7814,
    fill: "#CAEADB"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 176.008,
    width: 85.8144,
    height: 16.2352,
    fill: "#49AF68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343.814 176.008H360.823V192.243H343.814V176.008Z",
    fill: "#2A7940"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 293.562,
    y: 175.234,
    width: 14.6889,
    height: 17.7814,
    fill: "#C6E0D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_425_782",
    x: 166.805,
    y: 0,
    width: 159.498,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_425_782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_425_782",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServiceLoanStep1);
export default __webpack_public_path__ + "static/media/ImgServiceLoanStep1.adb2d65fc6a9d5a6ee36f23eb118d009.svg";
export { ForwardRef as ReactComponent };